import Act2021Driver from '@/public/jce/Struct.js';
import { TafFetch } from '@huyafed/taf-fetch'
import { fetchProd, getURLParam } from '@huyafed/utills'
import './wsChannel'
import { rich, jilu, total, day, hourc, hourr } from './data'

const mock = getURLParam('mock') !== null;
const random: (min: number, max: number) => number = (min: number, max: number) => Math.floor(Math.random() * (max - min)) + min
const RankItemMock: (count: number) => RankItem[] = (count: number) => {
  let i = 0;
  const data: RankItem[] = [];
  while (i < count) {
    data.push({
      tJump: {
        lPid: random(11111111, 99999999),
        iGameId: random(11111111, 99999999),
        iRoomId: random(11111111, 99999999),
        iIsLive: random(0, 2),
      },
      iRank: i + 1,
      lScore: random(11111111, 99999999),
      sNickName: 'mock name' + i + 1,
      sLogoUrl: '',
    })
    i += 1;
  }
  return data;
}

const HourRankItemMock: (count: number) => HourRankItem[] = (count: number) => {
  const data: RankItem[] = RankItemMock(count);
  return [...data.map((item: RankItem) => ({ tItem: item, iHour: random(0, 24) }))]
}

const AwardEventMock: (count: number) => AwardEvent[] = (count: number) => {
  let i = 0;
  const data: AwardEvent[] = [];
  while (i < count) {
    data.push({
      sNickName: 'mock name ' + i,
      sMsg: 'mock message ' + random(11111111, 99999999),
      lLotteryTime: 123456789,
    })
    i += 1;
  }
  return data;
}

export interface JumpChannel {
  lPid: number,
  iGameId: number,
  iRoomId: number,
  iIsLive: number,
}

export interface RankItem {
  tJump: JumpChannel,
  iRank: number,
  lScore: number,
  sNickName: string,
  sLogoUrl: string,
}

// 获取阶段
export interface StageReq {
  iDummy: number,
  lPid: number,
}

export interface StageRsp {
  iStage: number,
  iAreaId: number,
}

type DriverStage = (option: StageReq) => Promise<StageRsp>

// 老司机总榜
export interface DriverRankReq {
  lPid: number,
  iAreaId: number,
}
export interface DriverRankRsp {
  vItem: {
    value: RankItem[],
  },
  tItem: RankItem,
}
type DriverRank = (option: DriverRankReq) => Promise<DriverRankRsp>

// 老司机日榜
export interface DayRankReq {
  lPid: number,
  iAreaId: number,
}
export interface DayRankRsp {
  vItem: {
    value: RankItem[],
  },
  tItem: RankItem,
}
type DayRank = (option: DayRankReq) => Promise<DayRankRsp>

// 老司机小时榜
export interface HourRankReq {
  lPid: number,
  iAreaId: number,
}
export interface HourRankRsp {
  iHour: number,
  vItem: {
    value: RankItem[],
  },
  tItem: RankItem,
}
type HourRank = (option: HourRankReq) => Promise<HourRankRsp>

// 小时冠军
export interface HourChampionReq {
  lPid: number,
  iAreaId: number,
}
export interface HourRankItem {
  iHour: number,
  tItem: RankItem,
}
export interface HourChampionRsp {
  vItem: {
    value: HourRankItem[],
  },
}
type HourChampion = (option: HourChampionReq) => Promise<HourChampionRsp>

// 神豪榜
export interface RichRankReq {
  lPid: number,
}
export interface RichRankRsp {
  vItem: {
    value: RankItem[],
  },
}
type DriverRichRank = (option: RichRankReq) => Promise<RichRankRsp>

// 开奖记录
export interface AwardRecordReq {
  lPid: number,
}
export interface AwardEvent {
  sNickName: string,
  sMsg: string,
  lLotteryTime: number,
}
export interface AwardRecordRsp {
  vEvents: {
    value: AwardEvent[],
  },
}
type DriverAwardRecord = (option: AwardRecordReq) => Promise<AwardRecordRsp>

const tafFetch = new TafFetch({
  isProd: fetchProd(),
});

export const getDriverStage: DriverStage = (option: StageReq) => {
  // const req: any = new Act2021Driver.StageReq();
  // Object.keys(option).forEach(key => {
  //   req[key] = option[key];
  // })
  // if (!mock) return tafFetch.callWup('wupui', 'getDriverStage', req, Act2021Driver.StageRsp);
  return new Promise(Resolve => {
    Resolve({
      iAreaId: 0,
      iStage: 1,
    })
  })
}

export const getDriverRank: DriverRank = (option: DriverRankReq) => {
  // const req: any = new Act2021Driver.DriverRankReq();
  // Object.keys(option).forEach(key => {
  //   req[key] = option[key];
  // })
  // if (!mock) return tafFetch.callWup('wupui', 'getDriverRank', req, Act2021Driver.DriverRankRsp);
  return new Promise(Resolve => {
    Resolve(total['iArea' + option.iAreaId])
  })
}
export const getDriverDayRank: DayRank = (option: DayRankReq) => {
  // const req: any = new Act2021Driver.DayRankReq();
  // Object.keys(option).forEach(key => {
  //   req[key] = option[key];
  // })
  // if (!mock) return tafFetch.callWup('wupui', 'getDriverDayRank', req, Act2021Driver.DayRankRsp);
  return new Promise(Resolve => {
    Resolve(day['iArea' + option.iAreaId])
  })
}
export const getDriverHourRank: HourRank = (option: HourRankReq) => {
  const req: any = new Act2021Driver.HourRankReq();
  // Object.keys(option).forEach(key => {
  //   req[key] = option[key];
  // })
  // if (!mock) return tafFetch.callWup('wupui', 'getDriverHourRank', req, Act2021Driver.HourRankRsp);
  return new Promise(Resolve => {
    Resolve(hourr['iArea' + option.iAreaId])
  })
}
export const getDriverHourChampion: HourChampion = (option: HourChampionReq) => {
  // const req: any = new Act2021Driver.HourChampionReq();
  // Object.keys(option).forEach(key => {
  //   req[key] = option[key];
  // })
  // if (!mock) return tafFetch.callWup('wupui', 'getDriverHourChampion', req, Act2021Driver.HourChampionRsp);
  return new Promise(Resolve => {
    Resolve(hourc['iArea' + option.iAreaId])
  })
}
export const getDriverRichRank: DriverRichRank = (option: RichRankReq) => {
  // const req: any = new Act2021Driver.RichRankReq();
  // Object.keys(option).forEach(key => {
  //   req[key] = option[key];
  // })
  // if (!mock) return tafFetch.callWup('wupui', 'getDriverRichRank', req, Act2021Driver.RichRankRsp);
  return new Promise(Resolve => {
    Resolve(rich)
  })
}
export const getDriverAwardRecord: DriverAwardRecord = (option: AwardRecordReq) => {
  // const req: any = new Act2021Driver.AwardRecordReq();
  // Object.keys(option).forEach(key => {
  //   req[key] = option[key];
  // })
  // if (!mock) return tafFetch.callWup('wupui', 'getDriverAwardRecord', req, Act2021Driver.AwardRecordRsp);
  return new Promise(Resolve => {
    Resolve(jilu)
  })
}
